import { LoaderAction } from '../types/LoaderAction';

const loaderReducer = (state: number = 0, action: LoaderAction) => {
    switch (action.type) {
        case 'SHOW_LOADER':
            return state + 1;
        case 'HIDE_LOADER':
            const newState = state - 1;
            return newState < 0 ? 0 : newState;
        default:
            return state;
    }

}

export default loaderReducer;